import FormValidator from "base/FormValidator";
import EventEmitter from "base/EventEmitter";
import Measurements from "util/Measurements";
import FormInput from "base/FormInput";
import {scrollToElement} from "util/general";
import FileUploader, {EVENT_UPLOADING, EVENT_DONE} from "util/FileUploader";

export default class QuoteForm extends EventEmitter {
    constructor($element, data) {
        super();

        this.$element = $element;
        this.$form = this.$element.find('.js-product-form');
        this.data = data;

        this.measurements = new Measurements(this.$element.find('.js-measurements'));
        this.bindEvents();

        this.scrollingEnabled = false;
        this.updateFormFromData(this.data);
        this.scrollingEnabled = true;
    }

    bindEvents() {
        let me = this;

        this.fileUploader = new FileUploader(this.$element.find('.js-file-uploader'));

        this.fileUploader.on(EVENT_UPLOADING, () => {
            this.$form.find('button[type="submit"]').prop('disabled', true);
        }).on(EVENT_DONE, () => {
            this.$form.find('button[type="submit"]').prop('disabled', false);
        });

        this.validator = new FormValidator(this.$form, {
            inputOptions: {
                getMessage: function (type, context = {}) {
                    if (type !== 'success' && this.$input.is('.js-drop,.js-width')) {
                        return 'Required';
                    }
                    return FormInput.defaultOptions.getMessage.apply(this, arguments);
                }
            }
        });

        this.validator.on("submit", () => {
            this.updateData();
            this.emit('submit', this.getData());
        });

        this.validator.on("invalid", () => {
            console.log('error');
            let offset = $('.js-inline-validation:visible').first().closest('.js-form-section').offset().top - $('.js-header').outerHeight();
            $("html,body").stop().animate({scrollTop: offset}, 400);
        });

        this.measurements.on('build add remove', () => {
            this.validator.updateInputs();
        });

        this.$element.on('change', '.js-checkbox', function () {
            let $this = $(this);
            let checked = $this.is(":checked");

            if (checked) {
                $this.parents('.checkbox').addClass('checkbox--selected');
            } else {
                $this.parents('.checkbox').removeClass('checkbox--selected');
            }
        }).on('change', '.js-radio', function () {
            let $this = $(this);
            let name = $this.attr('name');

            me.$element.find('.js-radio[name="' + name + '"]').parents('.radio').removeClass('radio--selected');
            me.$element.find('.js-radio[name="' + name + '"]:checked').parents('.radio').addClass('radio--selected');
            me.$element.find('.js-submit-row button[type="submit"]').prop('disabled', false);
        }).on('change', '.js-product-type', () => {
            let value = this.$element.find('.js-product-type:checked').val();
            this.updateFormSections(value);
        }).on('change', '.js-can-provide-measurements', () => {
            let hasMeasurements = this.$element.find('.js-can-provide-measurements:checked').val() === 'yes';
            this.updateMeasurementsSection(hasMeasurements);

            if (this.scrollingEnabled && hasMeasurements) {
                scrollToElement(this.$element.find('.js-measurements-section'), 400, 20);
            }
        });
    }

    getData() {
        return this.data;
    }

    updateData() {
        let dataArray = this.$form.serializeArray();
        let data = {};

        dataArray.forEach((item) => {
            if (item.name.endsWith('[]')) {
                if (!Array.isArray(data[item.name])) {
                    data[item.name] = [];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        data.files = this.fileUploader.getFiles();

        data.measurements = this.measurements.getMeasurements();

        this.data = data;
    }

    updateMeasurementsSection(hasMeasurements) {
        if (hasMeasurements) {
            this.$element.find('.js-measurements-section').show();
            this.$element.find('.js-measurements-section input').prop('disabled', false);
        } else {
            this.$element.find('.js-measurements-section').hide();
            this.$element.find('.js-measurements-section input').prop('disabled', true);
        }
    }

    updateFormSections(type) {
        this.$element.find('.js-submit-row').show();

        if (['blinds', 'shutters'].indexOf(type) !== -1) {
            let $section = this.$element.find('.js-form-section')
            $section.show();
            if (this.scrollingEnabled) {
                scrollToElement($($section).first(), 400, 20);
            }

            this.$element.find('.js-form-section input, .js-form-section select').prop('disabled', false);

            this.$element.find('.js-type-text').text(type);
            this.$element.find('.js-type-text-capital').text(type.charAt(0).toUpperCase());
            this.updateTypeSelect(type);
            this.updateShownFeatures(type);

            let hasMeasurements = this.$element.find('.js-can-provide-measurements:checked').val() === 'yes';
            this.updateMeasurementsSection(hasMeasurements);
        } else {
            this.$element.find('.js-form-section').hide();
            this.$element.find('.js-form-section input, .js-form-section select').prop('disabled', true);
            this.$element.find('.js-measurements-section input, .js-measurements-section select').prop('disabled', true);
        }

        if (['pergolas'].indexOf(type) !== -1) {
            let $section = this.$element.find('.js-pergolas-section')
            $section.show();
            if (this.scrollingEnabled) {
                scrollToElement($($section).first(), 400, 20);
            }
            this.$element.find('.js-pergolas-section input, .js-pergolas-section select').prop('disabled', false);
        } else {
            this.$element.find('.js-pergolas-section').hide();
            this.$element.find('.js-pergolas-section input, .js-pergolas-section select').prop('disabled', true);
        }

        this.$element.find('.js-all-options').show();
    }

    updateShownFeatures(type) {
        this.$element.find('.js-feature-column').hide();
        this.$element.find('.js-feature-column .radio--selected').removeClass('radio--selected');
        this.$element.find('input[name="features[]"]').prop("checked", false).trigger('change');
        this.$element.find('.js-feature-column[data-type="' + type + '"]').show();
    }

    updateTypeSelect(type) {
        if (['blinds', 'shutters'].indexOf(type) === -1) {
            return;
        }

        let options = {
            'blinds': {
                "Please select": "",
                "Day and night blinds": "day-and-night-blinds",
                "Faux wood blinds": "faux-wood-blinds",
                "Perfect fit blinds": "perfect-fit-blinds",
                "Pleated blinds": "pleated-blinds",
                "Printed blinds": "printed-blinds",
                "Roller blinds": "roller-blinds",
                "Roman blinds": "roman-blinds",
                "Venetian blinds": "venetian-blinds",
                "Vertical blinds": "vertical-blinds",
                "Wood blinds": "wood-blinds",
                "Not sure": "not-sure",
            }, 'shutters': {
                "Please select": "",
                "Cafe style shutters": "cafe-style-shutters",
                "Full height shutters": "full-height-shutters",
                "Plantation shutters": "plantation-shutters",
                "Tiered shutters": "tiered-shutters",
                "Not sure": "not-sure",
            }
        };

        let $typeSelect = this.$element.find('.js-type-select');

        $typeSelect.empty();
        $.each(options[type], (key, value) => {
            if(value === ''){
                $typeSelect.append($("<option selected disabled></option>").attr("value", value).text(key));
            } else {
                $typeSelect.append($("<option></option>").attr("value", value).text(key));
            }
        });
    }

    updateFormFromData(data) {
        let excludedKeys = [];

        this.measurements.buildForm(data.measurements || []);

        Object.keys(data).forEach((key) => {
            if (excludedKeys.indexOf(key) !== -1) return;
            let value = data[key];

            let $input = this.$element.find("[name='" + key + "']");

            if ($input.is('[type="radio"]')) {
                $input.each((index, radio) => {
                    let $radio = $(radio);
                    let isActive = value === $radio.val();
                    $radio.prop('checked', isActive);

                    if (isActive) {
                        $radio.trigger('change');
                    }
                });
            } else if ($input.is('[type="checkbox"]')) {
                if (!Array.isArray(value)) {
                    value = [value];
                }

                $input.each((index, checkbox) => {
                    let $checkbox = $(checkbox);
                    let isActive = value.indexOf($checkbox.val()) !== -1;
                    $checkbox.prop('checked', isActive);
                    $input.trigger('change');
                });
            } else {
                $input.val(value);
            }

            if (key === 'product-type') {
                this.updateFormSections(value);
            }
        });

        this.validator.updateInputs();
    }
}
